import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=1f3e9e86&scoped=true&"
import script from "./WorkPlace.vue?vue&type=script&lang=js&"
export * from "./WorkPlace.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=1f3e9e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e9e86",
  null
  
)

export default component.exports